import React, {useEffect, useState} from 'react';
import {
  Grid,
  
  Paper, Typography, Autocomplete, Alert,  Box,
  Button, MenuItem, Select,
} from '@mui/material';

 
import AddIcon from '@mui/icons-material/PersonAdd';

import {usePlayContext} from '../utils/PlayContext';

import{useDataListContext} from '../utils/DataListContext'

import InviteEditorView from './InviteEditorView';

//import PersonRow from './PersonRow';

import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';

import PersonIcon from '@mui/icons-material/Person';
import EmailIcon from '@mui/icons-material/Email';
import PhoneIcon from '@mui/icons-material/Tty';
import CompanyIcon from '@mui/icons-material/Business';

// const regexEmail = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
// const regxPhone = /^\d{8,10}$/;

import { generatePhoneDetail } from '../utils/phoneUtil';

const PersonView=()=>
{

    //const [operation, setOperation] = useState('')

    const [dataChanged, setDataChanged] =useState(false) 
    const {op, setOp,nid, setNid, status, setStatus, appTitle, 
      setAppTitle, errorMessage, setErrorMessage, errorTitle, setErrorTitle}=usePlayContext()
    const {listData,  deleteDataList: doDeleteVisitor,} = useDataListContext();
  

    useEffect(()=>{},[])

    

    return (
    
      <Box sx={{p:0, m:1, borderBottom:0, borderTop:0, mt:2}} >
        
        <Grid container sx={{p:0, mt:1,border:1, borderColor:'#aaaaaa', borderRadius:1}} spacing={1}
            columns={18}>
              <Grid item xs={18} 
                sx={{py:0,pb:0 }} >
                <Box   
                  sx={{bgcolor:'none', border:0, p:{xs:0, sm:1}, m:0,width:'100%', 
                  display:'flex'}}>
                    <Typography  variant="h6"  sx={{mr:'auto', ml: {sm:1, xs:0}}}>
                        Visitors&nbsp;<small>[{listData.length}]</small>
                    </Typography>
                    <Button variant="outlined"sx={{mx:1}}  
                          disabled={Boolean(op)}  
                          onClick={()=>{setOp('add'); setNid('');}}
                          //variant='contained'
                          size='small'
                        >
                        <AddIcon sx={{mr:1,}}/>Add</Button>
                </Box>
              </Grid>
              <Grid item xs={18} 
                sx={{pt:0,  mb:{xs:1, md:0} }} >
                <Box   
                  sx={{bgcolor:'none', border:0, p:{xs:0, sm:1}, m:0,width:'100%', 
                  display:'flex'}}>
                    <Typography  variant="body2"  sx={{mr:'auto', ml: {sm:1, xs:0}}}>
                       <small>Note: Please provide all information if available, if not, please provide at least your visitor(s) email so that you can request for their profile.</small>
                    </Typography>
                </Box>
              </Grid>
          </Grid>
          {
            Boolean(op) &&
                <InviteEditorView/>
          
          }
          { !Boolean(op) &&
          <Grid container sx={{
              display:{xs:'none', md:'flex'},
              py:1, mt:1,border:1, borderColor:'#AAAAAA', borderRadius:1}} 
              columns={18}  spacing={1}>
          
              <Grid item xs={18} md={3} 
                  sx={{mx:1, }}>
                    <Typography  variant="body2"  
                          sx={{fontWeight:550, ml:1}}>
                      
                      Name
                    </Typography>
              </Grid>
              <Grid item xs={18} md={2} 
                          sx={{mx:1, }}>
                      <Typography  variant="body2"  
                      sx={{fontWeight:550, ml:1}}>
                        Phone Number
                      </Typography>
                  
              </Grid>
              <Grid item xs={18} md={4} 
                  sx={{mx:1, }}>
                    
                        <Typography  variant="body2"  
                        
                        sx={{fontWeight:550, ml:1}}>
                          Email
                        </Typography>
              </Grid>
              <Grid item xs={18} md={5} 
                  sx={{ mx:1, }}>
                    
                        <Typography  variant="body2"  
                          
                          sx={{fontWeight:550, ml:1}}>
                          Organization
                        </Typography>
                    
                </Grid>

                <Grid item xs={18} md={2} sx={{}}>
                  <Typography  variant="body2"  
                    textAlign={'center'}
                        sx={{fontWeight:550,}}>
                          Actions
                        </Typography>
                  
                </Grid>
          </Grid>
          }
            {
              !op && listData && listData.map(  
                (visitor, index)=>
                  (
                  <Grid  container key={visitor.nid} spacing={1}
                          columns={18}
                          sx={{p:1,
                          border:{xs:1,md:0},
                          borderColor:'#aaaaaa',
                          borderRadius:1,
                          bgcolor:`${(index%2)===0 ? "#EAF2F8":"#E9F7EF"}`}}>

                  <Grid item xs={17} md={3} 
                      sx={{mx:1, borderBottom: 1, borderBottomColor:'#cccccc'}}>
                        <Typography  variant="body2"  >
                        <PersonIcon size='small' color="primary"  sx={{mr:1, }}/>
                          {visitor.name}
                        </Typography>
                  </Grid>
                  <Grid item xs={17} md={2} 
                              sx={{mx:1, borderBottom: 1, borderBottomColor:'#cccccc'}}>
                          <Typography  variant="body2"  >
                            <PhoneIcon size='small' color="primary"  sx={{mr:1, }}/>
                        
                            {visitor.phoneDisplay}
                        
                          </Typography>
                  </Grid>

                  <Grid item xs={17} md={4} 
                      sx={{mx:1, borderBottom: 1, borderBottomColor:'#cccccc'}}>
                            <Typography  variant="body2"  >
                            <EmailIcon size='small' color="primary"  sx={{mr:1, }}/>
                              {visitor.email}
                            </Typography>
                  </Grid>
                  <Grid item xs={17} md={5} 
                      sx={{ mx:1, borderBottom: 1, borderBottomColor:'#cccccc'}}>
                        
                            <Typography  variant="body2"  >
                              <CompanyIcon size='small' color="primary"  sx={{mr:1, }}/>
                              {visitor.company}
                            </Typography>
                        
                    </Grid>

                    <Grid item xs={17} md={2} sx={{mx:'0px'}}>
                      <Box sx={{ display:'flex', justifyContent: 'space-evenly' , m:0,p:0}}
                          style={{padding:'0px',margin:'0px'}}
                      >
                      
                      <Button variant="outlined"size='small' 
						color='error' 
                          disabled={Boolean(op)}
                          onClick={(e)=>{doDeleteVisitor( visitor); setDataChanged(true);}}
                      ><DeleteIcon sx={{display:{xs:'none',lg:'block'}}}/>Delete</Button>
                      
                          

                      </Box>
                  </Grid>
                            
                </Grid>
                  )
              )
            }
        
        
      </Box>
    )

}

export default PersonView;
